<div mat-dialog-title>
  <div class="dialog-title">{{ 'POPUPS.NO_SELECTED_VERSION' | translate }}</div>
  <button mat-button mat-dialog-close tabindex="3" class="dialog-close">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<mat-dialog-content class="content">
  <div class="content__message">
    {{ message }}
  </div>
  <div class="inner">
    <app-versions-list
      [versions]="draftOnTopVersions"
      [diagramId]="diagramId"
      (navigation)="navigated()"></app-versions-list>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="mat-actions">
  <div class="version-info" *ngIf="versions.length">
    <a
      href="https://support.elements.cloud/en/articles/986385-diagram-versions-and-publishing-new-diagrams"
      matTooltip="{{ 'ASIDE_R.VERSIONS_INFORMATION' | translate }}"
      matTooltipShowDelay="400"
      matTooltipHideDelay="400"
      target="_blank">
      <button class="q9-icon-btn" type="button" mat-button>
        <mat-icon svgIcon="information" class="version-info__icon"></mat-icon>
      </button>
    </a>
  </div>
  <button mat-button color="primary" class="q9-btn q9-btn-border" tabindex="1" mat-dialog-close>
    {{ 'POPUPS.CANCEL' | translate }}
  </button>
</mat-dialog-actions>
